export default "__VITE_ASSET__CnVeF1On__"